/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function() {
  //
  // 特集コレクション(ランキング)
  //
  const tagButtonsContainer = document.querySelector('.c_tag-buttons');
  const rankingContainers = document.querySelectorAll('.c_ranking-container');

  function initializeDisplay() {
    const defaultButton = tagButtonsContainer.querySelector('.is-active');
    if (defaultButton) {
      const targetId = defaultButton.getAttribute('data-ranking-id');
      showContainer(targetId);
    } else {
      const firstContainer = rankingContainers[0];
      if (firstContainer) {
        firstContainer.style.visibility = 'visible';
        firstContainer.style.opacity = '1';
        firstContainer.style.height = 'auto';
      }
    }
  }

  function showContainer(targetId) {
    rankingContainers.forEach(container => {
      const containerId = container.getAttribute('data-ranking-id');
      container.style.visibility = containerId === targetId ? 'visible' : 'hidden';
      container.style.opacity = containerId === targetId ? '1' : '0';
      container.style.height = containerId === targetId ? 'auto' : '0';
    });
  }

  if (tagButtonsContainer) {
    const buttons = tagButtonsContainer.querySelectorAll('button');
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        buttons.forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        const targetId = button.getAttribute('data-ranking-id');
        showContainer(targetId);
      });
    });
    initializeDisplay();
  }

  //
  // フロートナビゲーション
  //
  const floatNavs = document.querySelectorAll('.c_float-nav');

  let lastScrollTop = 0;
  let ticking = false;

  function updateFloatNav() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    const isNearBottom = scrollTop + windowHeight > documentHeight - 50;
    const isNearTop = scrollTop <= 100;

    floatNavs.forEach(floatNav => { // 複数の要素をループ
      if (scrollTop > 100 && !isNearBottom) {
        fadeIn(floatNav);
      } else if (isNearTop || isNearBottom) {
        fadeOut(floatNav);
      }
    });

    lastScrollTop = scrollTop;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateFloatNav);
      ticking = true;
    }
  });

  function fadeIn(element) {
    element.style.opacity = 1;
    element.style.visibility = 'visible';
  }

  function fadeOut(element) {
    element.style.opacity = 0;
    setTimeout(() => {
      if (element.style.opacity === '0') {
        element.style.visibility = 'hidden';
      }
    }, 300);
  }

  // ページ読み込み時とリサイズ時にも更新
  window.addEventListener('load', updateFloatNav);
  window.addEventListener('resize', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateFloatNav);
      ticking = true;
    }
  });
  
});


//
// Recommendationのタイトルの高さを統一
// Boost AI Search & Discovery
//
document.addEventListener("DOMContentLoaded", () => {
  let prevHeights = new Map();
  let resizeTimer;
  let rcPlToShopifyBlockMap = new Map(); // boost-sd__rc-pl の .shopify-block を事前に記録

  function resetHeights(targetBlock) {
    targetBlock.querySelectorAll('.boost-sd__product-title, .boost-sd__product-item-grid-view-layout-image').forEach(el => {
      el.style.height = 'auto';
    });
    prevHeights.delete(targetBlock);
  }

  function equalizeHeightsForBlock(targetBlock) {
    const track = targetBlock.querySelector('.slick-track');
    if (!track) return;

    const titles = track.querySelectorAll('.boost-sd__product-title');
    const images = track.querySelectorAll('.boost-sd__product-item-grid-view-layout-image');

    if (!titles.length && !images.length) return;

    let maxTitleHeight = 0;
    let maxImageHeight = 0;

    titles.forEach(title => {
      maxTitleHeight = Math.max(maxTitleHeight, title.offsetHeight);
    });

    images.forEach(image => {
      maxImageHeight = Math.max(maxImageHeight, image.offsetHeight);
    });

    const prevTitleHeight = prevHeights.get(targetBlock)?.title || 0;
    const prevImageHeight = prevHeights.get(targetBlock)?.image || 0;

    if (maxTitleHeight !== prevTitleHeight || maxImageHeight !== prevImageHeight) {
      requestAnimationFrame(() => {
        titles.forEach(title => {
          title.style.height = `${maxTitleHeight}px`;
        });

        images.forEach(image => {
          image.style.height = `${maxImageHeight}px`;
        });

        prevHeights.set(targetBlock, { title: maxTitleHeight, image: maxImageHeight });
      });
    }
  }

  function watchBlockFor5Seconds(targetBlock) {
    const observer = new MutationObserver(() => {
      equalizeHeightsForBlock(targetBlock);
    });

    observer.observe(targetBlock, { childList: true, subtree: true, attributes: true });

    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  }

  function updateShopifyBlockMap() {
    document.querySelectorAll('.boost-sd__rc-pl').forEach(rcPl => {
      const shopifyBlock = rcPl.closest('.shopify-block');
      if (shopifyBlock) {
        rcPlToShopifyBlockMap.set(rcPl, shopifyBlock);
      }
    });
  }

  function watchRcPlDeletion() {
    updateShopifyBlockMap();

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.removedNodes.forEach(node => {
          if (node.classList?.contains('boost-sd__rc-pl')) {
            const shopifyBlock = rcPlToShopifyBlockMap.get(node);
            if (shopifyBlock) {
              equalizeHeightsForBlock(shopifyBlock);
              watchBlockFor5Seconds(shopifyBlock);
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('.shopify-block').forEach(block => {
        if (block.querySelector('.slick-track')) {
          resetHeights(block);
          equalizeHeightsForBlock(block);
        }
      });
    }, 200);
  });

  watchRcPlDeletion();
});

// ---
// staffstart
// 左メニュー店舗検索欄
// ---
// const targetSelector = "#staffstart-shopify-app-container .kYHZzj > div:nth-child(4)";

// // 要素の表示/非表示を切り替える関数
// const updateElementVisibility = () => {
//     const params = new URLSearchParams(window.location.search);
//     const target = document.querySelector(targetSelector);

//     if (target) {
//         if (params.has("staffLabelId")) {
//             target.style.display = "block";
//         } else {
//             target.style.display = "none";
//         }
//     }
// };

// // URL変更を検知して処理を実行する関数
// const observeUrlChange = () => {
//     let lastUrl = location.href;

//     new MutationObserver(() => {
//         const currentUrl = location.href;
//         if (currentUrl !== lastUrl) {
//             lastUrl = currentUrl;
//             updateElementVisibility();
//         }
//     }).observe(document.body, { childList: true, subtree: true });
// };

// // 初回実行（ページ読み込み時）
// updateElementVisibility();

// // URL変更を監視
// observeUrlChange();

// // 非同期で要素が追加された場合も対応
// const observer = new MutationObserver(() => {
//     updateElementVisibility();
// });
// observer.observe(document.body, { childList: true, subtree: true });

// ---
// スタッフ詳細、ブログタブ内とブログ一覧の時間非表示
// ---
document.addEventListener("DOMContentLoaded", function () {
  function removeTime() {
    document.querySelectorAll(".sc-fHjqPf.jJLVMR .sc-fqkvVR.fpkbiA").forEach(el => {
      if (el.dataset.processed) return; // 既に処理済みならスキップ
      el.textContent = el.textContent.trim().split(/\s+/)[0];
      el.dataset.processed = "true"; // 2重処理防止
    });
  }

  // 初回実行（すでに要素があれば処理）
  removeTime();

  // 定期的に処理（要素生成の遅延に対応）
  const interval = setInterval(removeTime, 1000); // 1秒ごとにチェック

  // MutationObserverで監視（動的追加に対応）
  const observer = new MutationObserver(() => {
    removeTime();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // 10秒経過したら interval を停止（無駄な処理を防ぐ）
  setTimeout(() => clearInterval(interval), 10000);
});


// 商品一覧 カラバリ選択時挙動
(function () {
  // data-product をパースしてキャッシュする
  const productCache = new WeakMap();

  function getProductData(card) {
    if (productCache.has(card)) return productCache.get(card);

    const raw = card.getAttribute('data-product');
    if (!raw) return null;

    try {
      const data = JSON.parse(raw);
      data._variantsParsed = JSON.parse(data.variants || '[]'); // 二重 JSON
      productCache.set(card, data);
      return data;
    } catch (e) {
      console.warn('Boost data-product parse error', e);
      return null;
    }
  }

  document.addEventListener('click', function (e) {
    const imgLink = e.target.closest('a.boost-sd__product-link-image');
    if (!imgLink) return; // メイン画像以外のクリックは無視

    const card = imgLink.closest('.boost-sd__product-item');
    if (!card) return;

    const data = getProductData(card);
    if (!data || !data._variantsParsed || !data.handle) return;

    // ★ 現在選択中のカラーラベルを取得（Boost がつけている selected クラス）
    const selectedLabel = card.querySelector(
      '.boost-sd__product-swatch--full-width .boost-sd__radio-label--selected'
    );

    // なければ何もしない（従来の href で遷移）
    if (!selectedLabel) return;

    const forId = selectedLabel.getAttribute('for');
    const input = forId ? document.getElementById(forId) : null;

    // 色名（value 優先、なければラベルテキスト）
    const colorName = (input && input.value
      ? input.value
      : selectedLabel.textContent
    ).trim();

    if (!colorName) return;

    const variants = data._variantsParsed;

    // title から該当バリアントを探す
    const matched = variants.find(function (v) {
      if (!v.title) return false;
      return (
        v.title.indexOf(colorName + ' /') === 0 ||
        v.title === colorName
      );
    });

    if (!matched || !matched.id) return;

    const variantId = matched.id;
    const href = '/products/' + data.handle + '?variant=' + variantId;

    // デフォルトのリンク遷移を止めて、こちらの URL へ飛ばす
    e.preventDefault();
    e.stopPropagation();

    // 念のため href 自体も書き換えておく
    imgLink.setAttribute('href', href);

    window.location.href = href;
  });
})();


// SPの商品一覧の絞り込みタブをスクロールされたら上に固定
document.addEventListener('DOMContentLoaded', () => {
  const headerHeight = 30;

  // 常に「最新の」toolbar を返す
  const getToolbar = () => document.querySelector('.boost-sd__toolbar-container');
  const getMobileNav = () => document.querySelector('mobile-navigation');

  let bar = getToolbar();
  let barTop = bar ? bar.getBoundingClientRect().top + window.scrollY : null;

  // mobile menu size 判定
  const hasSize = (el) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const syncZeroSizeClass = () => {
    const nav = getMobileNav();
    if (!bar || !nav) return;

    if (hasSize(nav)) {
      bar.classList.remove('is-nav-zero-size');
    } else {
      bar.classList.add('is-nav-zero-size');
    }
  };

  // mobile-navigation のサイズ変化を監視
  let resizeObserver = null;
  const watchNavResize = () => {
    const nav = getMobileNav();
    if (!nav) return;

    if (resizeObserver) resizeObserver.disconnect();

    resizeObserver = new ResizeObserver(() => {
      syncZeroSizeClass();
    });

    resizeObserver.observe(nav);
    syncZeroSizeClass();
  };


  // スクロール時の固定処理（元コードそのまま）
  const handleScroll = () => {
    if (!bar) return;
    if (window.scrollY > barTop - headerHeight) {
      bar.classList.add('is-fixed');
    } else {
      bar.classList.remove('is-fixed');
    }
  };

  // Boost が DOM を作り変えたら再取得
  const observer = new MutationObserver(() => {
    const newBar = getToolbar();
    if (newBar && newBar !== bar) {
      bar = newBar;
      barTop = bar.getBoundingClientRect().top + window.scrollY;
    }

    // navの再監視（Boost対策）
    requestAnimationFrame(() => {
      watchNavResize();
      syncZeroSizeClass();
    });
  });

  // ページ全体を監視（Boost の更新に対応）
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // スクロールイベント
  window.addEventListener('scroll', handleScroll);

  // 初期化
  watchNavResize();
  syncZeroSizeClass();
});
